import { MagicConfigMixin, SessionChange } from '@gig/magic-common';
import { Mixins, Prop, Component } from 'vue-property-decorator';
import { NotificationStyle, NotificationDelay } from '../../services/notifications/notifications.constants.js';
import '../../services/notifications/notification.js';
import { notificationService } from '../../services/notifications/notifications.service.js';
import '../../services/live-chat/live-chat.service.js';
import cookies from 'js-cookie';

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
const PWA_POPUP_COUNT = "pwa-popup-count";
let PWAInstallPopupComponent = class extends Mixins(MagicConfigMixin) {
  constructor() {
    super(...arguments);
    this.hasShownThisSession = false;
  }
  created() {
    if (!this.immediate) {
      return;
    }
    this.showNotification(true);
  }
  showNotification(shouldShow) {
    const navigator = window.navigator;
    if (this.hasShownThisSession || !shouldShow || navigator && navigator.standalone) {
      return;
    }
    const popupCount = +(cookies.get(PWA_POPUP_COUNT) || 0);
    if (popupCount < this.maxShowTimes) {
      notificationService.show(this.$t("notification.pwa-install"), {
        dismissible: true,
        style: NotificationStyle.INFO,
        closeDelay: this.notificationDelay,
        uniqueID: "notification-pwa-install"
      });
      cookies.set(PWA_POPUP_COUNT, (popupCount + 1).toString());
      this.hasShownThisSession = true;
    }
  }
  render() {
    return null;
  }
};
__decorateClass([
  Prop({
    type: Number,
    default: NotificationDelay.LONG
  })
], PWAInstallPopupComponent.prototype, "notificationDelay", 2);
__decorateClass([
  Prop({
    type: Number,
    default: 2
  })
], PWAInstallPopupComponent.prototype, "maxShowTimes", 2);
__decorateClass([
  Prop(Boolean)
], PWAInstallPopupComponent.prototype, "immediate", 2);
__decorateClass([
  SessionChange()
], PWAInstallPopupComponent.prototype, "showNotification", 1);
PWAInstallPopupComponent = __decorateClass([
  Component({
    name: "pwa-install-popup"
  })
], PWAInstallPopupComponent);

export default PWAInstallPopupComponent;
